// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="multiple-choice">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "other" ]

  handleOther(e) {
    let min = this.element.dataset.min
    let max = this.element.dataset.max
    let otherVal = this.otherTarget.value

    if (min === '1' && max === '1' && otherVal !== "") {
      $(this.element).find("input[type='checkbox']").prop("checked", false)
    }
  }

  check(e) {
    let min = this.element.dataset.min
    let max = this.element.dataset.max
    let selected = $(this.element).find("input[type='checkbox']:checked").length
    let otherVal = this.otherTarget.value
    if (otherVal !== "") {
      selected++
    }

    if (min === '1' && max === '1' && selected > 1) {
      this.otherTarget.value = ""
      $(this.element).find("input[type='checkbox']").prop("checked", false)
      $(e.target).prop("checked", true)
    }
  }
}
